export class StatisticsGroupMessage {
}
